"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathWithLanguage = exports.defaultLangKey = exports.langs = void 0;
const path_1 = __importDefault(require("path"));
exports.langs = ['ja'];
exports.defaultLangKey = 'ja';
exports.getPathWithLanguage = (lang, ...pathNames) => {
    const languagePrefix = lang === exports.defaultLangKey ? '' : lang;
    return path_1.default.join('/', languagePrefix, ...pathNames, '/');
};
